module.exports = __webpack_public_path__ + "5b7ca1bd5983e46326d97d8f5761c75d.woff";